//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
﻿(function () {

    angular
        .module('container.widgets')
        .directive('srsngLeftWorkflow', srsngLeftWorkflow);

    function srsngLeftWorkflow() {
        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/widgets/left-workflow/left-workflow.html',
            scope: {
                items: '=',
                disabled: '=?'
            },
            controller: controller
        };

        function controller($scope, $state, tabBarService) {
            $scope.isDone = isDone;
            $scope.isRequired = isRequired;
            $scope.isInProgress = isInProgress;
            $scope.isToDo = isToDo;
            $scope.changeTabState = changeTabState;
            $scope.hasSubItems = hasSubItems;
            $scope.isActiveState = isActiveState;

            function changeTabState(state, params) {
                tabBarService.changeTabState(state, params);
            };

            function isDone(item) {
                return item.filled === item.mandatory && item.mandatory > 0 && item.showMandatory;
            }

            function isRequired(item) {
                return item.filled === 0 && item.mandatory > 0 && item.showMandatory;
            }

            function isInProgress(item) {
                return item.filled > 0 && item.filled < item.mandatory && item.showMandatory;
            }

            function isToDo(item) {
                return !item.showMandatory;
            }

            function hasSubItems(item) {
                return item.subItems && item.subItems.length > 0;
            }

            function isActiveState(stateName) {
                return $state.current.name === stateName;
            };
        }

    }

}());